import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import UnAuth from '../../../src/assets/UnAuth.jpg';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const UnAuthComponent = () => {
    const navigate = useNavigate();

    const  {  Profile } = useSelector((state)=>state.common)
    const role=Profile?.profile?.role
    const isExternal=Profile?.profile?.isExternalRecruiter

    const handleGetBack = () => {
        if (role==='recruiter' && isExternal==="Y") {
            navigate('/jobpost')
        } else {
            navigate('/dashboard')
        }
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#fffff',
                px: 2,
            }}
        >
            <Grid
                container
                spacing={4}
                alignItems="center"
                justifyContent="center"
                sx={{
                    maxWidth: 1000,
                    mx: 'auto',
                }}
            >
                <Grid item xs={12} md={6} textAlign="center">
                    <Box
                        component="img"
                        src={UnAuth}
                        alt="Unauthorized"
                        sx={{
                            maxWidth: '100%',
                            height: 'auto',
                            borderRadius: 2,
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box textAlign="center">
                        <WarningAmberIcon
                            sx={{
                                fontSize: 60,
                                color: '#f44336',
                                mb: 2,
                                animation: 'bounce 1.5s infinite',
                            }}
                        />
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            Access Denied
                        </Typography>
                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            You are not authorized to access this page.
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<ArrowBackIcon />}
                            sx={{ mt: 3 }}
                            onClick={handleGetBack}
                        >
                            Go Back
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default UnAuthComponent;
